<div class="form-input">
  @if (label) {
    <label [for]="idHTML">
      {{ label | transloco }}@if (isRequired) {
      <span>*</span>
    }
    </label>
  }
  <mat-form-field [appearance]="appearance" class="uppercase">
    <input
      matInput
      [id]="idHTML"
      [matAutocomplete]="auto"
      [attr.maxlength]="maxLength"
      [attr.minlength]="minlength"
      [placeholder]="placeholder | transloco"
      [formControl]="_control"
      class="uppercase"
      onlyAlphabetic/>
    @if (idEditMode && _control.value) {
      <button mat-icon-button matSuffix (click)="clearInput()">
        <mat-icon>close</mat-icon>
      </button>
    }
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="onOptionSelected($event.option.value)"
      [displayWith]="displayLabel">
      @for (item of items; track item) {
        <mat-option [value]="item">
          {{ item.label }}
        </mat-option>
      }
    </mat-autocomplete>
    @if (_control.invalid) {
      <mat-error>
        {{ errorMessage | transloco: errorParams }}
      </mat-error>
    }
  </mat-form-field>
</div>
